import React, { useState } from "react";
import {
  Search,
  AlignJustify,
  X,
  SquareKanban,
  ShoppingBasket,
  GitCompare,
  ShoppingBag,
  PackageCheck,
  ReceiptText,
  LayoutDashboard,
  LogOut,
} from "lucide-react";
import { Link } from "react-router-dom";
// import SearchBar from "../socket/SearchBar";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/userSlice";
import Cookies from "js-cookie";

const TopNav = () => {
  const dispatch = useDispatch();

  const [searchString, setSearchString] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const [show, setShow] = useState(false);

  const staffName = useSelector((state) => state.user.staff_name);

  const handleBlur = () => {
    if (searchString.length === 0) {
      setIsSearch(false);
    }
  };

  const logOut = () => {
    Cookies.remove("access_token");
    dispatch(logout());
  };

  return (
    <div className="flex flex-col w-full mx-auto px-5  relative">
      <div className=" sm:block flex-1 relative">
        <div className="p-3  bg-[#fdfdfd] flex mt-4 items-center border shadow-md justify-between rounded-lg ">
          <div className="sm:hidden block">
            {show ? (
              <X onClick={() => setShow((curr) => !curr)} />
            ) : (
              <AlignJustify
                className="ham"
                onClick={() => setShow((curr) => !curr)}
              />
            )}
          </div>
          <div className="relative border-b  border-black  lg:w-96 sm:52">
            <input
              type="text"
              className="outline-none lg:w-80 sm:w-48 w-28 relative"
              placeholder="Search. . ."
              onChange={(e) => setSearchString(e.target.value)}
              onFocus={() => setIsSearch(true)}
              onBlur={(e) => handleBlur()}
            />
            <Search className="absolute top-0 right-0" />
          </div>
          <div className="flex w-1/2 lg:w-80 justify-end items-center gap-6">
            <h2 className="hidden sm:block text-lg font-semibold">
              Welcome {staffName}
            </h2>
            <button
              onClick={logOut}
              className="text-sm font-semibold p-1 px-2 mr-2 border shadow transform transition duration-150 ease-in-out hover:scale-105 active:scale-95"
            >
              <LogOut />
            </button>
          </div>
        </div>
      </div>

      {/* Search Option */}
      {/* {isSearch && <SearchBar searchString={searchString} />} */}

      <div
        className={` ${
          show ? "block" : "hidden"
        } border-b-2 transition-all w-[89%] min-h-24  bg-[#fdfdfd] rounded-b-md absolute top-[85%] z-10`}
      >
        <div className="flex flex-col">
          <ul className="flex flex-col bg-[#EEF5FF] flex-wrap gap-3 px-3.5 py-2 items-start justify-center shadow">
            <Link
              to="/dashboard"
              className="flex hover:bg-[#615EFC] w-full rounded p-2 bg-[#EEF5FF] items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <LayoutDashboard size={20} /> Dashbord
            </Link>
            <Link
              to="/"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <SquareKanban size={20} /> Indent{" "}
            </Link>
            <Link
              to="/report"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <ShoppingBasket size={20} />
              Item to Purchase
            </Link>
            <Link
              to="/quote-comparison"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <GitCompare size={20} />
              Quotation Comparison
            </Link>
            <Link
              to="/create-po"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <ShoppingBag size={20} />
              Create PO
            </Link>
           
            <Link
              to="/created-po-list"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <PackageCheck size={20} />
              Created Po
            </Link>
            <Link
              to="/receipt-note-report"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <ReceiptText size={20} />
              Receipt Note
            </Link>
            <Link
              to="/purchase-entry"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <ReceiptText size={20} />
              Purchase Entry
            </Link>
            <Link
              to="/purchase-payment"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <ReceiptText size={20} />
              Purchase Payment
            </Link>
            <Link
              to="/consumption-form"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <ReceiptText size={20} />
              Consumption Form
            </Link>
            <Link
              to="/production-form"
              className="flex hover:bg-[#615EFC] p-2 w-full rounded items-center gap-2"
              onClick={() => setShow((curr) => !curr)}
            >
              <ReceiptText size={20} />
              Production Form
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
